import { gtmOnclick } from "./gtmOnclick";

export const gtmOnclickRealizarSimulacion = () => {
  gtmOnclick({
    subZona: "Inicio",
    seccion: "Formulario",
    tipoEvento: "Clic",
    tipoElemento: "Botón",
    valor: "Realizar una simulación",
  });
};

export const gtmOnclickHablarConAsesor = (pageTitle) => {
  gtmOnclick({
    subZona: pageTitle,
    seccion: "Hablar con un asesor",
    tipoEvento: "Clic",
    tipoElemento: "Botón",
    valor: "Hablar con un asesor",
  });
};
